<template>
  <IQOS :title="'Партнер по доставці'">
    <img src="/icons/moeco.png" class="moeco-logo" />
    <p class="comment c-white">{{ $t('moeco_partner.title') }}</p>
    <p
      class="comment c-grey"
    >
    {{ $t('moeco_partner.connect_desc') }}
    </p>

    <div class="connect-wrapper iqos-group-item" v-if="!serviceStatus">
      <DashboardButton
        class="iqos-button-right"
        :disabled="busy"
        @click="connect"
      >{{ $t('moeco_partner.connect_btn') }}</DashboardButton>
    </div>
    <div class="connect-wrapper" v-if="serviceStatus == 'pending'">
      <hr />
      <p
        class="comment pt-0 c-white"
      >
        {{ $t('moeco_partner.pending_desc') }}
      </p>
    </div>
    <div class="connect-wrapper" v-if="serviceStatus == 'ready'">
      <!-- <hr /> -->
      <p class="comment c-green">
        {{ $t('moeco_partner.active') }}

      </p>
      <p class="comment c-white">{{ $t('moeco_partner.cost') }} {{ cafe.delivery.taxi_cost }} UAH</p>
      <p
        class="comment c-white"
      >{{ $t('moeco_partner.refuse_cost') }} {{ cafe.delivery.taxi_refuse_cost }} UAH</p>
    </div>

    <div>
      <hr>
      <CircleToggle
        :value="cafe.delivery.is_smart"
        @input="setSmartDelivery(true)"
      >{{ $t('moeco_partner.smart_option') }}</CircleToggle>
      <CircleToggle
        :value="!cafe.delivery.is_smart"
        class="iqos-group-item"
        @input="setSmartDelivery(false)"
      >{{ $t('moeco_partner.manual_option') }}</CircleToggle>
      <p class="comment c-grey" v-if="cafe.delivery.is_smart">
        {{ $t('moeco_partner.smart_desc') }}
      </p>
      <p class="comment c-grey" v-else>
        {{ $t('moeco_partner.manual_desc') }}
      </p>
    </div>

    <div v-if="false">
      <hr />

      <CircleToggle
        :value="cafe.delivery.taxi_payer == 'client'"
        @input="setPayer('client')"
      >{{ $t('moeco_partner.payer_client') }}</CircleToggle>
      <CircleToggle
        :value="cafe.delivery.taxi_payer == 'cafe'"
        @input="setPayer('cafe')"
        class="iqos-group-item"
      >{{ $t('moeco_partner.payer_cafe') }}</CircleToggle>
      <CircleToggle
        :value="cafe.delivery.taxi_payer == 'conditional'"
        @input="setPayer('conditional')"
        class="iqos-group-item"
      >{{ $t('moeco_partner.payer_conditional') }}</CircleToggle>

      <div v-if="cafe.delivery.taxi_payer == 'conditional'">
        <BaseInput 
          type="number"
          class="iqos-group-item"
          @blur="saveMinCheck"
          v-model.number="cost_min_check"
          :readonly="!editing"
          placeholder="100"/>
        <p class="comment c-grey">
          {{ $t('moeco_partner.conditional_desc') }}
        </p>
      </div>
    </div>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import IQOSActions from '@/components/IQOSActions.vue'
import DashboardButton from "@/components/DashboardButton.vue";

import CircleToggle from "@/components/CircleToggle.vue";
import BlackInput from "@/components/BlackInput.vue";
import RoundCheckbox from "@/components/RoundCheckbox.vue";

import MoecoAPI from "@/api/moeco";

export default {
  components: {
    DashboardButton,
    IQOS,
    IQOSActions,
    CircleToggle,
    RoundCheckbox,
    BlackInput
  },
  data() {
    return {
      busy: false,
      editing: false,

      cost_min_check: null
    };
  },
  methods: {
    connect() {
      this.busy = true;

      MoecoAPI.connect(this.cafe._id)
        .then((data) => {
          this.busy = false;

          this.$store.commit("setDeliveryServiceData", {
            service_tag: "moeco",
            service_status: "pending",
          });
        })
        .catch((error) => {
          this.busy = false;
          alert(`Не вдалось підключити доставку: ${error}`);
        });
    },
    setPayer(value) {
      if (!this.editing) return;
      this.$store.commit("setDeliveryTaxiPayer", value);
    },
    saveMinCheck() {
      this.$store.dispatch('saveCafe');
    },
    showEditUI() {
      this.editing = true;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    saveChanges() {
      this.$store.commit('setDeliveryCostMinCheck', this.cost_min_check);
      this.$store.dispatch("saveCafe");

      this.editing = false;
    },
    reset() {
      this.cost_min_check = this.cafe.delivery.cost_min_check || null;
    },
    setSmartDelivery(v) {
      this.$store.commit('setDeliverySmartFlag', v);
      this.$store.dispatch("saveCafe");
    }
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    serviceStatus() {
      if (this.cafe.delivery.service_tag != "moeco") return null;

      return this.cafe.delivery.service_status;
    },
  },
};
</script>

<style scoped>
.moeco-logo {
  width: 100%;
}
</style>